export const countPages = (count: number): number => {
  const countTotal = Math.ceil(count / 15);
  return countTotal;
};
